<template>
    <div
        class="B2BHero bg-[url('@/assets/images/homepage/thumbnails/job-thumbnail.png')] bg-cover bg-no-repeat sm:h-[686px]"
    >
        <div class="hero-wrap flex size-full flex-row justify-center">
            <div
                class="container flex h-full max-w-3xl flex-col items-center justify-center py-40 text-center text-white"
            >
                <CHeading variant="fat-italic-lg">
                    {{ content.title }}
                </CHeading>

                <CText class="mb-12 mt-6" variant="muted">
                    {{ content.description }}
                </CText>

                <div class="flex flex-col sm:flex-row">
                    <CButton class="mt-2.5 h-14 w-52" href="#sluzby" variant="primary">
                        Pozrite si našu ponuku
                    </CButton>

                    <CButton
                        class="mt-2.5 h-14 font-semibold text-white underline hover:no-underline"
                        href="#skusenosti"
                        variant="link"
                    >
                        Povedali o nás
                    </CButton>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'

import { B2BType } from '#shared/types/B2B'
import CButton from '@/components/ui/CButton.vue'
import CHeading from '@/components/ui/CHeading.vue'
import CText from '@/components/ui/CText.vue'

const CONTENT = {
    [B2BType.DEFAULT]: {
        title: 'Sme online miesto pre rast organizácií a jednotlivcov',
        description:
            'V GROWNi pomáhame rozvíjať hodnotovo orientovaných jednotlivcov, firmy a organizácie, ktorým záleží na tom, aby ich práca mala pozitívny dopad na Slovensko.'
    },

    [B2BType.GOV]: {
        title: 'Čo ponúkame organizáciám zo štátnej sféry na GROWNi',
        description:
            'Prepájame talentovaných a hodnotovo orientovaných ľudí s verejným sektorom, kde sa uplatnia na nových pracovných pozíciach či stážach alebo sa inak zapoja do správy verejnej.'
    },

    [B2BType.NGO]: {
        title: '',
        description: ''
    }
} as const

const props = defineProps({
    type: {
        type: String as PropType<B2BType>,
        default: B2BType.DEFAULT
    }
})

const content = computed(() => CONTENT[props.type])
</script>

<style lang="postcss" scoped>
.hero-wrap {
    background: linear-gradient(180deg, rgba(13, 14, 45, 0.83) 43.27%, #0d0e2d 100%);
}
</style>
